/* eslint-disable */
import authStateListener from '@/services/server/auth-service/authStateListener';
import store from '@/store';

const _ = require('lodash');

export default {
  async guardRoute(to, from, next) {
    const auth = store.getters['auth/isAuthenticated'];
    let isAuthenticated = true;
    if (!auth) {
      isAuthenticated = authStateListener.listenUserState()
        .then((res) => !!res)
        .catch(() => false);
    }

    Promise.resolve(isAuthenticated).then((isAuth) => {

      // route requires auth
      console.log('isAuth ?', isAuth);

      if (_.get(to, 'meta.auth') === true && !isAuth) {
        return next({ name: 'Login' });
      } else if (_.get(to, 'meta.guestOnly') === true && isAuth) {
        return next({ name: 'Dashboard' });
      }
      return next();
    });
  },
};
